import { FormProvider } from 'react-hook-form';

const Form = ({ methods, onSubmit, children }) => (
  <FormProvider {...methods}>
    <form onSubmit={onSubmit}>{children}</form>
  </FormProvider>
);

export default Form;
